import { httpRequest } from "../../http";
import type { Ad } from "@models/Ad.model";

export interface TagCollectionPage {
    tag_id: number;
    tag_name: string;
    tag_color?: string;
    hero?: string;
    copy_text?: string;
    ads: Ad[];
    /** ad_id -> tag ids (MPN-1575). */
    ad_tags?: Record<number, number[]>;
}

export class CommandGetTagCollection {
    async run(organizationId: string, tagId: string): Promise<TagCollectionPage | undefined> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${organizationId}/store/tags/${tagId}/`;
        try {
            return await httpRequest<TagCollectionPage>(url);
        } catch (error) {
            console.error("Error fetching tag collection:", error);
            throw error;
        }
    }
}
